import React, { Component } from 'react'

import Billboard from '../../components/billboard'
import Footer from '../../components/footer'
import Header from '../../components/header'
import Shelf from '../../components/shelf'
import {
	getVideos,
	filterByGenre,
	filterByFeatured,
} from '../../../common/contentful'
import Loading from '../../components/loading'

class Browse extends Component {
	constructor(props) {
		super(props)

		this.state = {
			titles: null
		}
	}

	componentDidMount() {
		this.mounted = true;

		if (this.state.titles === null) {
			getVideos((entries) => {
				if (this.mounted) {
					this.setState({
						titles: entries,
					})
				}
			})
		}
	}

	componentWillUnmount() {
		this.mounted = false;
  }

	render() {
		let rendered = null

		rendered = (
			<React.Fragment>
				<Header />
				<Loading />
				<Footer />
			</React.Fragment>
		)

		if (this.state.titles !== null) {
			const {
				titles,
			} = this.state

			const featuredVideo = filterByFeatured(titles)

			const fullLengthVideos = filterByGenre(titles, 'Full-Length Videos')
			const parts = filterByGenre(titles, 'Parts')
			const contests = filterByGenre(titles, 'Contests')
			const documentaries = filterByGenre(titles, 'Documentaries')
			const shopHomieVideos = filterByGenre(titles, 'Shop & Homie Videos')
			const tours = filterByGenre(titles, 'Tours')

			rendered = (
				<React.Fragment>
					<Header />
					<Billboard title={featuredVideo} />
					<Shelf header="Full-Length Videos" titles={fullLengthVideos} />
					<Shelf header="Parts" titles={parts} />
					<Shelf header="Contests" titles={contests} />
					<Shelf header="Documentaries" titles={documentaries} />
					<Shelf header="Shop & Homie Videos" titles={shopHomieVideos} />
					<Shelf header="Tours" titles={tours} />
					<Footer />
				</React.Fragment>
			)
		}

		return rendered
	}
}

export default Browse



// WEBPACK FOOTER //
// ./src/desktop/pages/browse/index.js